module.exports = __webpack_public_path__ + "static/media/2-en.b9164e7d.svg";